import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-38d3da34"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "taskListTableContainer" }
const _hoisted_2 = { class: "taskTitle" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "定时任务列表", -1))
const _hoisted_4 = { class: "example-pagination-block" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { size: "small" }, "只能选择当前时间五分钟之后的时间点", -1))

import { ref, computed, onMounted, onUnmounted } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import {
    Task,
    CrontabTask,
    TaskType,
    CrontabTaskStatusFilter,
    OptionConstruction,
    TaskTypesFilter,
    crontabIntervalType,
    crontabDailyType,
    crontabOnceType,
    TaskStatusEnum,
} from "@/store/modules/task/types";
import { Upload, InfoFilled } from '@element-plus/icons-vue';
import { ArrowDown } from '@element-plus/icons-vue'
import { taskAPI } from '@/api/task'


import { defineComponent } from 'vue';

const __default__ = defineComponent({
    name: "CrontabTaskListTable",
});


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const store = useStore();
const route = useRoute();
const crontabList = ref<CrontabTask[]>([])
const currentPage = ref<number>(1)
const pageSize = ref<number>(10)
const total = ref<number>(0)
const isLoading = ref<boolean>(false)
const crontabDialogVisiable = ref<boolean>(false)
const selectedTask = ref<CrontabTask>()
const crontabType = ref<number>()
const crontabTime = ref<string>('00:00:59')
const intervalTime = ref<number>(2)
const sizeChange = (val: number) => {
    pageSize.value = val
}
const handleDateChange = ref<boolean>(false)

const crontabOptionList: OptionConstruction[] = [
    {
        label: "周期任务（需选择每次任务执行的时间间隔）",
        value: crontabIntervalType,
    }, {
        label: "单次定时任务（需选择本次任务执行的时间点）",
        value: crontabOnceType,
    }, {
        label: "每日定时任务（需选择每日任务执行的时间点）",
        value: crontabDailyType,
    },
]

const projectId = computed(
    () => typeof (route.params.projId) === "string" ? route.params.projId : route.params.projId[0]
);
const targetId = computed(
    () => typeof (route.params.targetId) === "string" ? route.params.targetId : route.params.targetId[0]
);
const disabledDate = (time: Date): boolean => {
    const now = new Date(new Date().getTime() + 5 * 60000); // 5min after
    if (time.getMonth() !== now.getMonth()) return time.getMonth() < now.getMonth()
    if (time.getDate() !== now.getDate()) {
        return time.getDate() < now.getDate()
    } else {
        if (time.getHours() === 0 && time.getMinutes() === 0 && time.getSeconds() === 0) return false
        if (time.getHours() !== now.getHours()) {
            return time.getHours() < now.getHours()
        } else {
            return time.getMinutes() <= now.getMinutes()
        }
    }
}
const getDisplaySchedualTime = (data: CrontabTask): string => {
    const date = (new Date(new Date(new Date(data.scheduleTime).toUTCString()).getTime() + 8 * 60 * 60 * 1000)).toISOString()
    if (data.runMode === crontabOnceType) {
        return date.substring(0, 10) + "  " + date.substring(11, 16)
    } else if (data.runMode === crontabDailyType) {
        return '每日' + date.substring(11, 16)
    }
    return ''
}

const getType = (data: Task): string => {
    let taskType = TaskType.get(data.type)
    if (typeof taskType === "string") {
        return taskType
    } else {
        return "unknown"
    }
}

const filterForChange = (value: string, row: any, column: any) => {
    return row[column['property']] === value;
}

const handleCommand = async (data: string | number | object) => {
    const projId = projectId.value
    const uid = targetId.value
    const { command, task } = data

    if (command === "edit") {
        selectedTask.value = task
        crontabDialogVisiable.value = true
        crontabType.value = task.runMode
        intervalTime.value = task.duration / 1000000000 / 60 / 60
        let timeOrigin = new Date(new Date(task.scheduleTime).toUTCString()).getTime()
        let timeNow = (new Date(new Date(new Date().toUTCString()).getTime())).toISOString()
        if (task.runMode == crontabDailyType) {
            const dateObj: Date = new Date(new Date(task.scheduleTime).getTime() + 8 * 60 * 60 * 1000)
            const hours: number = dateObj.getUTCHours();
            const minutes: number = dateObj.getUTCMinutes();
            crontabTime.value = hours + ":" + minutes + ":59"
        } else {
            crontabTime.value = timeOrigin <= new Date().getTime() ? timeNow : (new Date(new Date(new Date(task.scheduleTime).toUTCString()).getTime() + 8 * 60 * 60 * 1000)).toISOString()
        }
    } else if (command === "delete") {
        await taskAPI.DeleteCrontbTaskStatus(projId, uid, task.taskId)
        handleRefresh()
    }
}

const TimeFormat = (type: number, timeOrigin: string): string => {
    if (type === crontabOnceType) {
        return new Date(timeOrigin).toISOString()
    } else if (type === crontabDailyType) {
        var currentDate = new Date();
        var [hours, minutes] = timeOrigin.split(":").map(Number);
        currentDate.setHours(hours, minutes, 0, 0);
        return currentDate.toISOString()
    }
    return "0001-01-01T00:00:00Z"
}

const updateOnSubmit = async () => {
    const projId = projectId.value
    const uid = targetId.value
    await taskAPI.UpdateCrontbTaskStatus({ "projId": projId, "uid": uid, "taskId": selectedTask.value!.taskId, "crontabType": crontabType.value!, "crontabTime": TimeFormat(crontabType.value!, crontabTime.value!), "intervalTime": crontabType.value === crontabIntervalType ? intervalTime.value : 0 })
    crontabDialogVisiable.value = false
    handleRefresh()
}
const handleRefresh = async () => {
    crontabList.value = []
    crontabList.value = await taskAPI.GetCrontabTaskList(projectId.value, targetId.value)
}
onMounted(async () => {
    crontabList.value = await taskAPI.GetCrontabTaskList(projectId.value, targetId.value)
    total.value = crontabList.value.length
})


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_time_picker = _resolveComponent("el-time-picker")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_button, {
          type: "primary",
          style: {"float":"right","margin-right":"10px"},
          onClick: handleRefresh
        }, {
          default: _withCtx(() => [
            _createTextVNode("刷新")
          ]),
          _: 1
        }),
        _hoisted_3
      ]),
      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        data: crontabList.value.slice((currentPage.value - 1) * pageSize.value, currentPage.value * pageSize.value)
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            prop: "taskId",
            label: "任务ID"
          }),
          _createVNode(_component_el_table_column, {
            prop: "runMode",
            label: "定时任务类型",
            filters: _unref(CrontabTaskStatusFilter),
            "filter-multiple": false,
            "filter-method": filterForChange
          }, {
            default: _withCtx((scope) => [
              (scope.row.runMode === _unref(crontabIntervalType))
                ? (_openBlock(), _createBlock(_component_el_tag, {
                    key: 0,
                    type: ""
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("周期")
                    ]),
                    _: 1
                  }))
                : (scope.row.runMode === _unref(crontabOnceType))
                  ? (_openBlock(), _createBlock(_component_el_tag, {
                      key: 1,
                      type: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("单次")
                      ]),
                      _: 1
                    }))
                  : (scope.row.runMode === _unref(crontabDailyType))
                    ? (_openBlock(), _createBlock(_component_el_tag, {
                        key: 2,
                        type: ""
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("每日")
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["filters"]),
          _createVNode(_component_el_table_column, {
            prop: "type",
            label: "类型",
            filters: _unref(TaskTypesFilter),
            "filter-method": filterForChange,
            "filter-multiple": false
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(getType(scope.row)), 1)
            ]),
            _: 1
          }, 8, ["filters"]),
          _createVNode(_component_el_table_column, {
            prop: "status",
            label: "状态",
            "filter-multiple": false
          }, {
            default: _withCtx((scope) => [
              (scope.row.status === _unref(TaskStatusEnum).StatusIdle)
                ? (_openBlock(), _createBlock(_component_el_tag, {
                    key: 0,
                    type: "info"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("未知")
                    ]),
                    _: 1
                  }))
                : (scope.row.status === _unref(TaskStatusEnum).StatusProcessing)
                  ? (_openBlock(), _createBlock(_component_el_tag, { key: 1 }, {
                      default: _withCtx(() => [
                        _createTextVNode("处理中")
                      ]),
                      _: 1
                    }))
                  : (scope.row.status === _unref(TaskStatusEnum).StatusDownloading)
                    ? (_openBlock(), _createBlock(_component_el_tag, { key: 2 }, {
                        default: _withCtx(() => [
                          _createTextVNode("获取中")
                        ]),
                        _: 1
                      }))
                    : (scope.row.status === _unref(TaskStatusEnum).StatusFinished)
                      ? (_openBlock(), _createBlock(_component_el_tag, {
                          key: 3,
                          type: "success"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("成功")
                          ]),
                          _: 1
                        }))
                      : (scope.row.status === _unref(TaskStatusEnum).StatusFailed)
                        ? (_openBlock(), _createBlock(_component_el_tag, {
                            key: 4,
                            type: "danger"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("错误")
                            ]),
                            _: 1
                          }))
                        : (scope.row.status === _unref(TaskStatusEnum).StatusPending)
                          ? (_openBlock(), _createBlock(_component_el_tag, {
                              key: 5,
                              type: "info"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("等待")
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            prop: "duration",
            label: "任务间隔时间"
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(scope.row.runMode !== _unref(crontabIntervalType) ? '-' : scope.row.duration / 1000000000 / 60 / 60 + 'h'), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            prop: "scheduleTime",
            label: "计划时间"
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(scope.row.runMode === _unref(crontabIntervalType) ? '-' : getDisplaySchedualTime(scope.row)), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, { label: "操作" }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_dropdown, { onCommand: handleCommand }, {
                dropdown: _withCtx(() => [
                  _createVNode(_component_el_dropdown_menu, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_dropdown_item, {
                        command: { command: 'edit', task: scope.row }
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("编辑")
                        ]),
                        _: 2
                      }, 1032, ["command"]),
                      _createVNode(_component_el_dropdown_item, {
                        command: { command: 'delete', task: scope.row }
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("删除")
                        ]),
                        _: 2
                      }, 1032, ["command"])
                    ]),
                    _: 2
                  }, 1024)
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_el_button, { type: "primary" }, {
                    default: _withCtx(() => [
                      _createTextVNode(" 操作"),
                      _createVNode(_component_el_icon, { class: "el-icon--right" }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(ArrowDown))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 2
              }, 1024)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"])), [
        [_directive_loading, isLoading.value]
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_el_pagination, {
        "current-page": currentPage.value,
        "onUpdate:currentPage": _cache[0] || (_cache[0] = ($event: any) => ((currentPage).value = $event)),
        background: true,
        layout: " prev, pager, next",
        "page-sizes": [5, 10, 20],
        "default-page-size": 10,
        total: total.value,
        onSizeChange: sizeChange
      }, null, 8, ["current-page", "total"])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: crontabDialogVisiable.value,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((crontabDialogVisiable).value = $event)),
      title: "编辑定时任务"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, { "label-width": "150px" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "任务Id" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(selectedTask.value.id), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "任务类型" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(getType(selectedTask.value)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "定时任务类型" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: crontabType.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((crontabType).value = $event)),
                  placeholder: "请选择",
                  width: "200"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(crontabOptionList, (option) => {
                      return _createVNode(_component_el_option, {
                        key: option.value,
                        value: option.value,
                        label: option.label
                      }, null, 8, ["value", "label"])
                    }), 64))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            (crontabType.value === _unref(crontabIntervalType))
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  label: "选择任务间隔时间"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input_number, {
                      modelValue: intervalTime.value,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((intervalTime).value = $event)),
                      min: 2,
                      size: "small"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }))
              : (crontabType.value === _unref(crontabOnceType))
                ? (_openBlock(), _createBlock(_component_el_form_item, {
                    key: 1,
                    label: "选择执行时间"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_date_picker, {
                        modelValue: crontabTime.value,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((crontabTime).value = $event)),
                        type: "datetime",
                        "value-format": "YYYY-MM-DD HH:mm:ss",
                        format: "YYYY-MM-DD HH:mm",
                        placeholder: "请选择任务执行时间",
                        "disabled-date": disabledDate,
                        "default-time": new Date(new Date().setHours(0, 0, 59))
                      }, null, 8, ["modelValue", "default-time"]),
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(InfoFilled))
                        ]),
                        _: 1
                      }),
                      _hoisted_5
                    ]),
                    _: 1
                  }))
                : (crontabType.value === _unref(crontabDailyType))
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 2,
                      label: "选择每日执行时间"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_time_picker, {
                          modelValue: crontabTime.value,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((crontabTime).value = $event)),
                          placeholder: "请选择每日执行时间",
                          "value-format": "HH:mm",
                          format: "HH:mm",
                          "default-value": new Date()
                        }, null, 8, ["modelValue", "default-value"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: updateOnSubmit
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("提交")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (crontabDialogVisiable.value = false))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("取消")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})